"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockFunction = void 0;
var mockFunction = function (any) {
    if (process.env.NODE_ENV === 'development') {
        return any;
    }
};
exports.mockFunction = mockFunction;
//# sourceMappingURL=mock.js.map